import AppShell from '@/components/layout/AppShell'
import CatalogBootstrap from '@/components/CatalogBootstrap'
import AuthGate from '@/auth/AuthGate'
import { useWallClockTick } from '@/hooks/useWallClockTick'

export default function App() {
  useWallClockTick()
  return (
    <AuthGate>
      <CatalogBootstrap />
      <AppShell />
    </AuthGate>
  )
}
